import { InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';

import { StoreSelector } from './store-selector.const';
import { State } from './store.interface';
import * as Reducer from './store.reducer.index';

export const reducers = new InjectionToken<ActionReducerMap<State>>('NgRxReducers', {
  factory: () => {
    return {
      [StoreSelector.Help]: Reducer.Help,
      [StoreSelector.Logo]: Reducer.Logo,
      [StoreSelector.Auth]: Reducer.Auth,
      [StoreSelector.User]: Reducer.User,
      [StoreSelector.Cache]: Reducer.Cache,
      [StoreSelector.System]: Reducer.System,
      [StoreSelector.Catalog]: Reducer.Catalog,
      [StoreSelector.UserPrefs]: Reducer.UserPrefs,
      [StoreSelector.AppVersion]: Reducer.AppVersion,
      [StoreSelector.Connection]: Reducer.Connection,
      [StoreSelector.OpenedTasks]: Reducer.OpenedTasks,
      [StoreSelector.PendingTasks]: Reducer.PendingTasks,
      [StoreSelector.Configuration]: Reducer.Configuration,
      [StoreSelector.SessionRefresh]: Reducer.SessionRefresh,
      [StoreSelector.Digitalization]: Reducer.Digitalization,
      [StoreSelector.ElementVisibility]: Reducer.ElementVisibility,
      [StoreSelector.ProductMaintenance]: Reducer.ProductMaintenance
    } as ActionReducerMap<State>;
  }
});
